import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { MdStore, MdLockOpen } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import Card from '../../commons/Card/Card'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import BoyContent from '../../commons/Ilustrations/BoyContent'
import CardContentSmall from '../../commons/CardContentSmall/CardContentSmall'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import Avatar from '../../commons/Avatar/Avatar'
import styles from './profileContainer.module.scss'

const GRADIENT = 99

const ProfileContainer = () => {
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.profileReducer)

  useEffect(() => {
    dispatch(reducks.resources.profile.actions.getProfile(100))
  }, [])

  const personal = true
  const company = true
  const security = false

  return (
    <DefaultLayout>
      <Flex column>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Meu perfil
        </Text>

        <div className={styles.row}>
          {personal && (
            <Card className={styles.cardMargin}>
              <Flex
                column
                alignItems="flex-start"
                justifyContent="space-evenly"
              >
                <div className={styles.mb20}>
                  <Avatar
                    title={profile.profile.name}
                    image={profile.profile.profileImageUrl}
                    size="medium"
                  />
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  bold
                  lineHeight="24px"
                >
                  {profile.profile.name}
                </Text>
                <Link to={routes.profileDetail.path} className={styles.action}>
                  <Text size="xs" color="gray" font="custom" lineHeight="24px">
                    Editar dados pessoais
                  </Text>
                </Link>
              </Flex>
            </Card>
          )}
          {company && (
            <Card className={styles.cardMargin}>
              <Flex
                column
                alignItems="flex-start"
                justifyContent="space-evenly"
              >
                <div className={styles.mb20}>
                  <Thumbnail type={GRADIENT}>
                    <MdStore size={25} />
                  </Thumbnail>
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  bold
                  lineHeight="24px"
                >
                  Dados da Empresa
                </Text>
                <Link
                  to={routes.profileStoreDetail.path}
                  className={styles.action}
                >
                  <Text size="xs" color="gray" font="custom" lineHeight="24px">
                    Veja os dados de CNPJ
                  </Text>
                </Link>
              </Flex>
            </Card>
          )}
          {security && (
            <Card className={styles.cardMargin}>
              <Flex
                column
                alignItems="flex-start"
                justifyContent="space-evenly"
              >
                <div className={styles.mb20}>
                  <Thumbnail type={GRADIENT}>
                    <MdLockOpen size={25} />
                  </Thumbnail>
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  bold
                  lineHeight="24px"
                >
                  Segurança
                </Text>
                <Link to="" className={styles.action}>
                  <Text size="xs" color="gray" font="custom" lineHeight="24px">
                    Altere a sua senha
                  </Text>
                </Link>
              </Flex>
            </Card>
          )}
        </div>
      </Flex>

      <Text
        size="lg"
        color="gray"
        variation="dark"
        extraBold
        lineHeight="30px"
        margin="48px 0px 0px 0px"
      >
        Conteúdo Salvo
      </Text>

      <div className={styles.row}>
        {profile.fetching && <LoadingBounce />}
        {!profile.fetching &&
          profile.profile.contentFavorites &&
          profile.profile.contentFavorites.length > 0 &&
          profile.profile.contentFavorites.map((item) => (
            <CardContentSmall
              key={item.id}
              title={item.title}
              updatedAt={item.lastUpdateFormatted}
              isMarked={item.isFavorite}
              category={item.category.code}
              onPress={() => {
                history.push(
                  routes.contentDetail.path.replace(':contentId', item.id)
                )
              }}
              pressMarker={() => {
                dispatch(
                  reducks.resources.knowledgeBase.actions.toggleFavorite({
                    key: 'recents',
                    item
                  })
                ).then(() => {
                  dispatch(reducks.resources.profile.actions.getProfile(100))
                })
              }}
            />
          ))}

        {!profile.fetching && profile.profile.contentFavorites?.length === 0 && (
          <Card className={styles.full}>
            <FeedbackLayout
              title="Conteúdo"
              subTitle="Você ainda não favoritou nenhum conteúdo."
              secondaryAction={() => history.push(routes.content.path)}
              secondaryLabelAction="Ir para conteúdos"
              Ilustration={BoyContent}
              textAlign="center"
              center
            />
          </Card>
        )}
      </div>
    </DefaultLayout>
  )
}

export default ProfileContainer
